let protocol = window.location.protocol
const CONSTANTS={
	initViewConfig:{//初始化视图位置配置
		longitude:114.117903,
		latitude:22.673965,
		height:140000,
		heading:0,
		pitch:-90,
		roll:0
	},
	LAYER:{
		FOURCOLOR:'fourColorLayer',//四色图图层
		WORKER:'workerLayer',//员工图层
		ELEFENCE:"eleFenceLayer",//电子围栏图层
        CAMERA:"cameraLayer",//摄像头图层
        WORKORDER:"workOrderLayer",//作业票图层
        ALARM:"alarmLayer",//报警图层
        DEVICEDATA:"deviceDataLayer",//设备数据图层
        DEVICE:"deviceLayer"//设备图层
    },
    TILE:{//瓦片配置
      VECTOR:{//高德地图
        id: 'gaode',
        name: '高德地图',
        type: 'url_imagery',
        minLevel: 1,
        maxLevel: 18,
        isGCJ02: true,
        show:false,
        shouldLocate:false,
        url: `${protocol}//webrd02.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}`
      },
      IMG:{//高德影像
        id: "gaodeimg",
        name: "高德影像",
        type: 'url_imagery',
        minLevel: 1,
        maxLevel: 18,
        isGCJ02: true,
        show:true,
        shouldLocate:false,
        baseId:'gaode',
        url: `${protocol}//webst02.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}`
      },
      ROADNET:{//高德路网
        id: "gaoderoadnet",
        name: "高德路网",
        type: 'url_imagery',
        minLevel: 1,
        maxLevel: 18,
        isGCJ02: true,
        shouldLocate:false,
        url: `${protocol}//webst02.is.autonavi.com/appmaptile?x={x}&y={y}&z={z}&lang=zh_cn&size=1&scale=1&style=8`
      }
    }
};

export default CONSTANTS;
